import { render } from "./SgnksoView.vue?vue&type=template&id=05ba7b4c"
import script from "./SgnksoView.vue?vue&type=script&lang=js"
export * from "./SgnksoView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__